<template>
  <div>
    <div class="sb_poem-preview" v-if="poem">
      <span v-if="name">Lieve {{ name }}, <br />
        &nbsp; <br /></span>
      {{ poem }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import handleError from "../lib/errorHandling";

export default {
  data() {
    return {
      poemId: this.$route.params.id,
      poem: "",
      name: this.$route.query.name,
    };
  },
  mounted() {
    this.fetchPoem();
  },
  methods: {
    getName() { },
    async fetchPoem() {
      const url = `${process.env.VUE_APP_BACKEND_BASE_URL}poems/${this.poemId}`;
      console.log("fetch poem", url);
      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = response.data;
        this.poem = data;
        console.log(data);
      } catch (e) {
        handleError(e);
      }
    },
  },
  watch: {
    // Watch the $route object for changes, useful if the ID can change without the component being destroyed/recreated
    $route(to, from) {
      this.poemId = to.params.id;
      this.fetchPoem();
    },
  },
};
</script>

<style lang="scss">
html {
  overflow: initial;
}

body {
  padding: 2rem;
  color: white;
  white-space: pre-line;
  font-size: 1.125rem;
  font-size: clamp(1.125rem, 0.5rem + 1.5625vw, 1.75rem);

  @media print {
    color: black;
    break-inside: avoid;
  }
}
</style>
